import { BehaviorSubject } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, output, inject, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { StyleClassModule } from 'primeng/styleclass';
import { LostDealReasonComponent } from './utility/lost-deal-reason/lost-deal-reason.component';
import { ClientService } from '@fitness-force/api';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-lost-deal',
  templateUrl: './lost-deal.component.html',
  styleUrls: ['./lost-deal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogModule,
    InputTextModule,
    ButtonModule,
    StyleClassModule,
    ReactiveFormsModule,
    LostDealReasonComponent,
    TranslateModule,
    AsyncPipe
]
})
export class LostDealComponent {
  private clientService = inject(ClientService);

  readonly showDailog = input(false);
  readonly lostDealInfo = input<any>();
  readonly closeMainDailog = output<boolean>();
  readonly reload = output<boolean>();

  showLostToCompetitors = false;
  showLostToPrice = false;
  showLostToOtherReasons = false;
  showLostNotContactable = false;
  showLosttoMissingFacility = false;
  lostDealReason: any = new BehaviorSubject({ title: '', name: '' })
  togglelostReason = false;


  showReasonDailog(reason: string, name: string) {
    this.togglelostReason = true
    this.lostDealReason.next({ title: reason, name: name })
  }
  closeReasonDialog() {
    this.togglelostReason = false
    this.lostDealReason.next({ title: '', name: '' })
  }
  closeAllDialogs() {
    this.closeReasonDialog()
    this.closeMainDailog.emit(true)
  }
  reloadData() {
    this.reload.emit(true)
  }

  clientStatus(client: any): string {
    if (client && client.status) {
      return this.clientService.getClientStatusHtml(client.status.toString());
    }
    return '';
  }


}
